import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inventoryList: [],
  defaultInventory: [],
  sceneList: [],
  fetchSceneRef:true
};

const projectSlice = createSlice({
  name: "projectSlice",
  initialState,
  reducers: {
    saveInventoryList: (state, action) => {
      state.inventoryList = action.payload.data
    },
    saveDefaultInventoryList: (state, action) => {
      state.defaultInventory = action.payload.data;
    },
    saveSceneList: (state, action) => {
      state.sceneList = action.payload.data;
    },
    resetSceneList: (state, action) => {
      state.sceneList = [];
    },
    resetInventoryList: (state, action) => {
        state.inventoryList = [];
        state.defaultInventory = [];
    },
    triggerFetchScene:(state)=>{
      state.fetchSceneRef = !(state.fetchSceneRef)
    }
  },
});

export const { saveInventoryList, saveDefaultInventoryList, resetInventoryList, saveSceneList, resetSceneList, triggerFetchScene } = projectSlice.actions;
export default projectSlice.reducer;
